export default {
  calendar: {
    today: 'Hoy',
    tomorrow: 'Mañana',
    asap: 'Lo antes posible',
  },
};
